/**
 * El paso de texto plano a HTML de correo, y la vuelta.
 *
 * ☠️ Vive en el paquete COMPARTIDO, no en el navegador, porque lo usan los dos
 * lados: el editor de campañas al guardar y el envío de prueba de una plantilla
 * en el servidor. Estuvo duplicado unas horas y las dos copias divergieron justo
 * en lo que decide si un correo lleva enlaces medibles o no.
 */
/**
 * Una dirección http(s) suelta dentro del texto. Se aplica sobre el texto YA
 * ESCAPADO, donde no queda ningún `<` ni `>` de verdad, así que parar en ellos
 * es seguro.
 */
const URL_SUELTA = /https?:\/\/[^\s<>"']+/g;
/**
 * Puntuación que casi siempre es de la frase y no de la dirección: «entra en
 * https://jr2.es/oferta.» El punto y coma se deja fuera a propósito, porque es
 * el final de las entidades HTML (`&amp;`) que el escapado acaba de meter.
 */
const PUNTUACION_FINAL = /[.,!?)\]]+$/;
/**
 * El cuerpo se escribe en texto normal; el HTML lo pone el sistema al enviar.
 *
 * ☠️ LAS DIRECCIONES SE CONVIERTEN EN ENLACES DE VERDAD, y no es un adorno: es
 * el ÚNICO camino por el que el cuerpo de una campaña puede llegar a tener un
 * `<a href>`. Sin esto, el escapado convierte todo en texto, el medidor de clics
 * no encuentra ni un enlace que medir y toda campaña sale con cero clics
 * medidos — sin que nadie se entere, porque un cero parece un resultado.
 *
 * El orden importa: primero escapar (para que nadie pueda meter etiquetas
 * escribiendo en el textarea), luego enlazar sobre lo escapado, y solo al final
 * convertir los saltos de línea.
 */
export function textoAHtml(texto) {
    const escapado = texto.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    const conEnlaces = escapado.replace(URL_SUELTA, (encontrada) => {
        const cola = PUNTUACION_FINAL.exec(encontrada)?.[0] ?? '';
        const url = cola ? encontrada.slice(0, -cola.length) : encontrada;
        if (!url)
            return encontrada;
        return `<a href="${url}">${url}</a>${cola}`;
    });
    const conSaltos = conEnlaces.replace(/\n/g, '<br/>');
    return `<div style="font-family:sans-serif;font-size:14px;line-height:1.5;color:#0f172a">${conSaltos}</div>`;
}
/** La vuelta, para poder reabrir un borrador guardado antes. */
export function htmlATexto(html) {
    return html
        .replace(/<br\s*\/?>/gi, '\n')
        .replace(/<[^>]+>/g, '')
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        .replace(/&amp;/g, '&')
        .trim();
}
/**
 * El teléfono en la forma que espera `wa.me`: solo dígitos, con prefijo de país.
 *
 * ☠️ Asume ESPAÑA cuando el número no trae prefijo, porque es de donde son todos
 * los clientes de JR2 hoy. Si algún día hay clientes fuera, esto miente en
 * silencio: por eso devuelve null en cuanto el número no encaja en un patrón
 * reconocible, en vez de inventarse un prefijo.
 */
export function telefonoParaWhatsApp(bruto) {
    if (!bruto)
        return null;
    const limpio = bruto.replace(/[\s.\-()]/g, '');
    if (/^\+\d{8,15}$/.test(limpio))
        return limpio.slice(1);
    if (/^00\d{8,15}$/.test(limpio))
        return limpio.slice(2);
    // Móvil español: nueve dígitos que empiezan por 6 o 7.
    if (/^[67]\d{8}$/.test(limpio))
        return `34${limpio}`;
    return null;
}
//# sourceMappingURL=marketing-body.js.map